import request from '@/utils/axios';

export const ossSts = () => request.get(`/third/aliyun/oss/sts`);
export const sendCode = p => request.post(`/third/open/aliyun/sms/send/${p}`);
